// Javascript Dependecies
import Vue from "vue";
import VueRouter from "vue-router";
import api from "services/account";
import store from "./vuex/store";
import menuModule from "vuex-store/modules/menu";
import { EventBus } from "./event-bus";
import lazyLoading from "./vuex/store/modules/menu/lazyLoading";

// Lazyloading Views...

// Backend views

const AdminLayout = () => import(/* webpackChunkName: "group-admin" */ './admin/views/Layouts/App')
const AdminConnection = () => import(/* webpackChunkName: "group-admin" */ './admin/views/Connection')
const DashboardCandidates = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Candidates')
const DashboardSchedules = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/ApplicationsToScheduleList')
const DashboardDocuments = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Documents')
const DashboardNotifications = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Notifications')
const DashboardAppointments = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Appointments')
const DashboardMessages = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Messages')
const DashboardTasks = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Tasks')
const DashboardAccountingBalances = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/Balances')
const DashboardCodesBourse = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/CodesBourse')
const CommercialDashboardMyRelances = () => import(/* webpackChunkName: "group-admin" */ './admin/views/commercial-dashboard/MyRelancesDetail.vue')
const CommercialDashboardDrilldown = () => import(/* webpackChunkName: "group-admin" */ './admin/views/commercial-dashboard/Drilldown.vue')
const CommercialDashboardEventRegistrations = () => import(/* webpackChunkName: "group-admin" */ './admin/views/commercial-dashboard/EventRegistrations.vue')

const DashboardChangeRequests = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/ChoiceChangeRequests')
const DashboardUnverifiedAccounts = () => import(/* webpackChunkName: "group-admin" */ './admin/views/dashboard/UnverifiedAccounts')

const EditCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/AccountCandidate')
const AccountsList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/AccountsList')
const EditPaymentsCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/orders/Orders')
const EditCreditsCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/credits/Credits')
const AddCandidateOffers = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/offers/Index')
const SchoolCandidateOffers = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/offers/Offers')
const EditFinanceCandidate = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/AccountCandidate')
const PaymentsList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/PaymentsList')
const PaymentsCheckList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/PaymentsCheckList')
const PaymentsCashFlow = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/PaymentsCashFlow')
const TotalCashFlow = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/TotalCashFlow')
const MonthlyBilling = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/MonthlyBilling')
const MonthlyCommercials = () => import(/* webpackChunkName: "group-admin" */ './admin/views/finances/MonthlyCommercials')
const EmailSuppressions = () => import(/* webpackChunkName: "group-admin" */ './admin/views/settings/EmailSuppressions')
const ReminderList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/ReminderList')
const AttendantList = () => import(/* webpackChunkName: "group-admin" */ './admin/views/candidates/AttendantList')
const EditDocument = () => import(/* webpackChunkName: "group-admin" */ './admin/views/documents/Document')
const EditTraining = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/Training')
const ImportTrainingDates = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/ImportDates')
const ImportTrainingCapacities = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/ImportCapacities.vue')
const EditOffer = () => import(/* webpackChunkName: "group-admin" */ './admin/views/offers/OfferForm.vue')
const EditOfferCategory = () => import(/* webpackChunkName: "group-admin" */ './admin/views/offers/CategoryForm.vue')
const EditPromoCode = () => import(/* webpackChunkName: "group-admin" */ './admin/views/offers/PromoCodeForm.vue')
const EditSchool = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/School')
const EditCampus = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/Campus')
const EditEvent = () => import(/* webpackChunkName: "group-admin" */ './admin/views/events/Event')
const Stats = () => import(/* webpackChunkName: "group-admin" */ './admin/views/trainings/Stats')


// Common schools pages
const MainLayout = () => import(/* webpackChunkName: "group-schools" */ './components/layouts/main')
const Jpo = () => import(/* webpackChunkName: "group-schools" */ './components/pages/jpo')

const Webinaire = () => import(/* webpackChunkName: "group-schools" */ './components/pages/webinaire')
const Atelier = () => import(/* webpackChunkName: "group-schools" */ './components/pages/atelier')
const JpoLive = () => import(/* webpackChunkName: "group-schools" */ './components/pages/jpoLive')
const JpoDoc = () => import(/* webpackChunkName: "group-schools" */ './components/pages/jpoDoc')
const Process = () => import(/* webpackChunkName: "group-schools" */ './components/pages/admissionProcess')
const Connection = () => import(/* webpackChunkName: "group-schools" */ './components/login/connection')
const Registration = () => import(/* webpackChunkName: "group-eschool" */ './components/login/registration')
const ResetPassword = () => import(/* webpackChunkName: "group-schools" */ './components/login/resetPassword')
const EmailVerification = () => import(/* webpackChunkName: "group-schools" */ './components/login/EmailVerification')
const NotFoundPage = () => import(/* webpackChunkName: "group-schools" */ './components/errors/404')

// Highschool views
const Home = () => import(/* webpackChunkName: "group-highschool" */ './highschool/views/pages/home')
const HighSchoolApplication = () => import(/* webpackChunkName: "group-highschool" */ './highschool/views/pages/application')
const Contract = () => import(/* webpackChunkName: "group-highschool" */ './highschool/views/pages/scholarContract')


// Echool views
const EschoolHome = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/home')
const EschoolApplication = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/application')
const EschoolProfile = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/profile')
const EschoolContract = () => import(/* webpackChunkName: "group-eschool" */ './eschool/views/pages/scholarContract')
const EshopHome = () => import(/* webpackChunkName: "group-eschool" */ './components/shop/views/pages/offers')
const EshopInternship = () => import(/* webpackChunkName: "group-eschool" */ './components/shop/views/pages/internships')
const EshopConnection = () => import(/* webpackChunkName: "group-eschool" */ './components/shop/views/pages/connection')

const StaffProfile = () => import(/* webpackChunkName: "group-admin" */ './admin/views/staff/Profile.vue')


Vue.use(VueRouter);

// List of All Routes in Your Application
const routes = [
  {
    path: "/verify-email/:token",
    component: EmailVerification,
    name: "email-verification",
    meta: {
      hasMenu: false
    }
  },
  {
    path: "/admin",
    component: AdminLayout,
    meta: {
      isAdmin: true
    },
    children: [
      {
        path: '/admin/staff/profile',
        name: 'staff-profile',
        component: StaffProfile,
        meta: {
          requiresAuth: true,
          title: 'Mon Profil'
        }
      },
      {
        path: "/admin/dashboard/candidats",
        component: DashboardCandidates,
        name: "dashboard-candidates",
        meta: {
          label: "Liste",
          title: "Liste des candidats",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/dashboard/schedules",
        component: DashboardSchedules,
        name: "dashboard-schedules",
        meta: {
          label: "Relances",
          title: "Gestion des relances",
          permissions: "manage schedules"
        }
      },
      {
        path: "/admin/dashboard/tasks/staff",
        component: DashboardTasks,
        name: "dashboard-staff-tasks",
        meta: {
          label: "Mes Tâches",
          title: "Tâches à éffectuer",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/dashboard/codes-bourse",
        component: DashboardCodesBourse,
        name: "dashboard-codes-bourse",
        meta: {
          label: "Codes bourses",
          title: "Derniers codes bourses utilisés",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/dashboard/unverified-accounts",
        component: DashboardUnverifiedAccounts,
        name: "dashboard-unverified-accounts",
        meta: {
          label: "Comptes non vérifiés",
          title: "Comptes email non vérifié",
          permissions: "list accounts"
        }
      },
      {
        path: "/admin/dashboard/choice-change-requests",
        component: DashboardChangeRequests,
        name: "choice-change-requests",
        meta: {
          label: "Demandes de changement",
          title: "Demandes de changement de choix",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/dashboard/tasks",
        component: DashboardTasks,
        name: "dashboard-tasks",
        meta: {
          label: "Tâches",
          title: "Toutes les tâches",
          permissions: "access all tasks"
        }
      },
      {
        path: "/admin/dashboard/accounting/balances",
        component: DashboardAccountingBalances,
        name: "dashboard-accounting-balances",
        meta: {
          label: "Balances",
          title: "Balances client",
          permissions: "access cashflow accountability"
        }
      },
      {
        path: "/admin/dashboard/documents",
        component: DashboardDocuments,
        name: "dashboard-documents",
        meta: {
          label: "Liste",
          title: "Documents des candidats",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/dashboard/notifications",
        component: DashboardNotifications,
        name: "dashboard-notifications",
        meta: {
          label: "Liste",
          title: "Notifications",
          permissions: "list monitored"
        }
      },
      {
        path: "/admin/dashboard/appointments",
        component: DashboardAppointments,
        name: "dashboard-appointments",
        meta: {
          label: "Liste",
          title: "RDV et ED"
        }
      },
      {
        path: "/admin/dashboard/messages/:type",
        component: DashboardMessages,
        name: "dashboard-messages",
        meta: {
          label: "Liste",
          title: "Messages",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/commercial-dashboard/my-relances",
        component: CommercialDashboardMyRelances,
        name: "commercial-dashboard-my-relances",
        meta: {
          label: "Mes relancés",
          title: "Détail de mes relancés",
          permissions: [
            "view own commercial dashboard",
            "view all commercial dashboards"
          ]
        }
      },
      {
        path: "/admin/commercial-dashboard/drilldown",
        component: CommercialDashboardDrilldown,
        name: "commercial-dashboard-drilldown",
        meta: {
          label: "Drilldown",
          title: "Détail dashboard commercial",
          permissions: [
            "view own commercial dashboard",
            "view all commercial dashboards"
          ]
        }
      },
      {
        path: "/admin/commercial-dashboard/event-registrations",
        component: CommercialDashboardEventRegistrations,
        name: "commercial-dashboard-event-registrations",
        meta: {
          label: "Inscriptions aux événements",
          title: "Inscriptions aux événements",
          permissions: [
            "view own commercial dashboard",
            "view all commercial dashboards"
          ]
        }
      },

      {
        path: "/admin/candidat/:userId/edit",
        component: EditCandidate,
        name: "edit-candidate",
        meta: {
          label: "Edition",
          title: "Editer un candidat",
          permissions: "create candidate"
        }
      },
      {
        path: "/admin/candidat/:userId/paiements",
        component: EditPaymentsCandidate,
        name: "edit-payments-candidate",
        meta: {
          label: "Règlement",
          title: "Règlement et historique",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/candidat/:userId/offres",
        component: AddCandidateOffers,
        name: "add-candidate-offers",
        meta: {
          label: "Offres",
          title: "Ajouter une offre",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/candidat/:userId/offres/:school",
        component: SchoolCandidateOffers,
        name: "school-offers",
        meta: {
          label: "Offres",
          title: "Ajouter une offre",
          permissions: "list offers"
        },
        children: [
          {
            path: "categorie/:categoryId",
            component: SchoolCandidateOffers,
            name: "admin-shop-category",
            meta: {
              permissions: "list offers"
            },
          },
          {
            path: "categorie/:categoryId/:offerId",
            component: SchoolCandidateOffers,
            name: "admin-shop-offer",
            meta: {
              permissions: "list offers"
            },
          },
        ]
      },
      {
        path: "/admin/accounts/liste",
        component: AccountsList,
        name: "list-accounts",
        meta: {
          label: "Liste des candidats",
          title: "Comptes"
        }
      },
      {
        path: "/admin/finance/:userId/edit",
        component: EditFinanceCandidate,
        name: "edit-finance-candidate",
        meta: {
          label: "Edition",
          title: "Editer un candidat",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/finance/:userId/credits",
        component: EditCreditsCandidate,
        name: "edit-credits-candidate",
        meta: {
          label: "Avoirs",
          title: "Avoirs",
          permissions: "list candidates"
        }
      },
      {
        path: "/admin/finances/:type",
        component: PaymentsList,
        name: "payments-list",
        meta: {
          label: "Liste",
          title: "Liste des paiements",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/finances/checks/:status",
        component: PaymentsCheckList,
        name: "payments-checks",
        meta: {
          label: "Liste",
          title: "Liste des paiements",
          permissions: "access finances"
        }
      },
      {
        path: "/admin/finances/total/cashflow",
        component: TotalCashFlow,
        name: "total-cashflow",
        meta: {
          label: "Liste",
          title: "Trésorerie",
          permissions: "access cashflow"
        }
      },
      {
        path: "/admin/settings/email-suppressions",
        component: EmailSuppressions,
        name: "email-suppressions",
        meta: {
          label: "Suppressions email",
          title: "Suppressions email"
        }
      },
      {
        path: "/admin/finances/billing/monthly",
        component: MonthlyBilling,
        name: "monthly-billing",
        meta: {
          label: "Facturation Mensuelle",
          title: "Facturation Mensuelle",
          permissions: "export finance applications"
        }
      },
      {
        path: "/admin/finances/commercials/monthly",
        component: MonthlyCommercials,
        name: "monthly-commercials",
        meta: {
          label: "Résultats Commerciaux",
          title: "Résultats Commerciaux",
          permissions: "export finance applications"
        }
      },
      {
        path: "/admin/finances/cashflow/:status",
        component: PaymentsCashFlow,
        name: "payments-cashflow",
        meta: {
          label: "Liste",
          title: "Trésorerie",
          permissions: "access cashflow"
        }
      },
      {
        path: "/admin/relances/:status",
        component: ReminderList,
        name: "reminder-list",
        meta: {
          label: "Relances",
          title: "Relances",
          permissions: "dashboard application reminder"
        }
      },
      {
        path: "/admin/accompagnes/:status",
        component: AttendantList,
        name: "attendant-list",
        meta: {
          label: "Accompagnés",
          title: "Accompagnés",
          permissions: "dashboard application attendant"
        }
      },
      {
        path: "/admin/documents/:document/edit",
        component: EditDocument,
        name: "edit-document",
        meta: {
          label: "Edition",
          title: "Editer le document",
          permissions: "create document"
        }
      },
      {
        path: "/admin/documents/new",
        component: EditDocument,
        name: "new-document",
        meta: {
          title: "Nouveau document",
          label: "Ajouter",
          permissions: "create document"
        }
      },
      {
        name: "import-dates",
        component: ImportTrainingDates,
        path: "/admin/trainings/dates/import",
        meta: {
          title: "Import",
          label: "Importer des dates",
          permissions: "edit training_dates"
        },
      },
      {
        name: "import-capacities",
        component: ImportTrainingCapacities,
        path: "/admin/trainings/capacities/import",
        meta: {
          title: "Import",
          label: "Importer des capacités",
          permissions: "edit training_capacities"
        },
      },
      {
        path: "/admin/training/:trainingId/edit",
        component: EditTraining,
        name: "edit-training",
        meta: {
          label: "Edition",
          title: "Editer la formation",
          permissions: "edit training"
        }
      },

      {
        path: "/admin/training/new",
        component: EditTraining,
        name: "new-training",
        meta: {
          title: "Nouvelle formation",
          label: "Ajouter",
          permissions: "create training"
        }
      },
      {
        path: "/admin/offers/:offerId/edit",
        component: EditOffer,
        name: "edit-offer",
        meta: {
          label: "Edition",
          title: "Editer l'offre",
          permissions: "list offers"
        }
      },
      {
        path: "/admin/offer/new",
        component: EditOffer,
        name: "new-offer",
        meta: {
          title: "Nouvelle offre",
          label: "Ajouter",
          permissions: "create offer"
        }
      },
      {
        path: "/admin/offer/category/:category/edit",
        component: EditOfferCategory,
        name: "edit-offer-category",
        meta: {
          label: "Edition",
          title: "Modifier la catégorie"
        }
      },
      {
        path: "/admin/offer/category/new",
        component: EditOfferCategory,
        name: "new-offer-category",
        meta: {
          title: "Nouvelle catégorie",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/offer/promo-codes/:promo/edit",
        component: EditPromoCode,
        name: "edit-promo-code",
        meta: {
          title: "Modifier le code bourse",
          label: "Edition"
        }
      },
      {
        path: "/admin/offer/promo-codes/new",
        component: EditPromoCode,
        name: "new-promo-code",
        meta: {
          title: "Nouveau code bourse",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/registre",
        component: Stats,
        name: "stats",
        meta: {
          label: "Registre",
          title: "Registre",
          permissions: "access register"
        }
      },
      {
        path: "/admin/school/:school/edit",
        component: EditSchool,
        name: "edit-school",
        meta: {
          label: "Edition",
          title: "Modifier l'école"
        }
      },
      {
        path: "/admin/school/new",
        component: EditSchool,
        name: "new-school",
        meta: {
          title: "Nouvelle école",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/campus/:campus/edit",
        component: EditCampus,
        name: "edit-campus",
        meta: {
          label: "Edition",
          title: "Modifier le campus"
        }
      },
      {
        path: "/admin/campus/new",
        component: EditCampus,
        name: "new-campus",
        meta: {
          title: "Nouveau campus",
          label: "Ajouter"
        }
      },
      {
        path: "/admin/event/:eventId/edit",
        component: EditEvent,
        name: "edit-event",
        meta: {
          label: "Edition",
          title: "Editer l'événement",
          permissions: "edit event"
        }
      },
      {
        path: "/admin/lab/lead-scoring/guide",
        name: "lead-scoring-guide",
        component: lazyLoading("lab/LeadScoringGuide", true),
        meta: {
          title: "Lead Scoring Guide",
          superadminOnly: true
        }
      },
      {
        path: "/admin/lab/lead-scoring/monitoring",
        name: "lead-scoring-monitoring",
        component: lazyLoading("lab/LeadScoringMonitoring", true),
        meta: {
          title: "Lead Scoring Monitoring",
          superadminOnly: true
        }
      },
      {
        path: "/admin/lab/lead-scoring/pilotage",
        name: "lead-scoring-pilotage",
        component: lazyLoading("lab/LeadScoringPilotage", true),
        meta: {
          title: "Pilotage Lead Scoring",
          superadminOnly: true
        }
      },
      ...generateRoutesFromMenu(menuModule.state.items)
    ]
  },
  {
    path: "/admin/login",
    component: AdminConnection,
    name: "admin-connection"
  },
  {
    path: "/admissionsup/forgotpassword/:token",
    alias: "/admission/forgotpassword/:token",
    component: ResetPassword,
    name: "reset",
    meta: {
      schoolType: 'highschool',
      hasMenu: false
    }
  },
  {
    path: "/admissioneschool/forgotpassword/:token",
    component: ResetPassword,
    name: "eschool-reset",
    meta: {
      schoolType: 'eschool',
      hasMenu: false
    }
  },
  {
    path: "/admissionsup",
    alias: "/admissions",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: Home,
        name: "highschool-list",
        meta: {
          schoolType: 'highschool',
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/jpo/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: Jpo,
        name: "jpo",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/atelier/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: Atelier,
        name: "atelier",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/webinaire/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: Webinaire,
        name: "webinaire",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/live/:school/",
    component: MainLayout,
    children: [
      {
        path: "",
        component: JpoLive,
        name: "live",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/documentation/:school",
    component: MainLayout,
    children: [
      {
        path: "",
        component: JpoDoc,
        name: "documentation",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissionsup/:school/offres",
    alias: "/admission/:school/offres",
    component: MainLayout,
    meta: {
      schoolType: 'highschool'
    },
    children: [
      {
        path: "",
        component: EshopHome,
        name: "highschool-categories",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "sessions",
        component: EshopInternship,
        name: "highschool-internship",
        meta: {
          schoolType: 'highschool'
        }
      },
      {
        path: "categorie/:categoryId",
        component: EshopHome,
        name: "highschool-category",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "categorie/:categoryId/:offerId",
        component: EshopHome,
        name: "highschool-offer",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "paiement",
        component: EshopHome,
        name: "highschool-checkout",
        meta: {
          schoolType: 'highschool',
        }
      },
      {
        path: "commande/:orderId",
        component: EshopHome,
        name: "highschool-order",
        meta: {
          schoolType: 'highschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "connexion",
        component: EshopConnection,
        name: "connection-highschool",
        meta: {
          hasMenu: false
        }
      },
      {
        path: "inscription",
        component: EshopConnection,
        name: "registration-highschool",
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissionsup/:school/profil",
    alias: "/admission/:school/profil",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: EschoolProfile,
        name: "highschool-profile",
        meta: {
          schoolType: 'highschool',
          isCandidate: true,
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/admissionsup/:school",
    alias: "/admission/:school",
    component: MainLayout,
    meta: {
      schoolType: 'highschool'
    },
    children: [
      {
        path: "",
        component: HighSchoolApplication,
        name: "highschool-home",
        meta: {
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "mon-compte",
        component: HighSchoolApplication,
        name: "profile",
        meta: {
          schoolType: 'highschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "procedure",
        component: Process,
        name: "process"
      },
      {
        path: "contrat",
        component: Contract,
        name: "contrat"
      },
      {
        path: "connexion",
        component: Connection,
        name: "highschool-connection",
        meta: {
          schoolType: 'highschool',
          hasMenu: false
        }
      },
      {
        path: "inscription",
        component: Registration,
        name: "highschool-registration",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          schoolType: 'highschool',
          hasMenu: false
        }
      },
      {
        path: '404',
        alias: '*',
        component: NotFoundPage,
        name: "highschool-not-found"
      }
    ]
  },

  // Eschool routes
  {
    path: "/admissioneschool/:school/offres",
    component: MainLayout,
    meta: {
      schoolType: 'eschool'
    },
    children: [
      {
        path: "",
        component: EshopHome,
        name: "eshop-categories",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "sessions",
        component: EshopInternship,
        name: "eshop-internship",
        meta: {
          schoolType: 'eschool'
        }
      },
      {
        path: "categorie/:categoryId",
        component: EshopHome,
        name: "eshop-category",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "categorie/:categoryId/:offerId",
        component: EshopHome,
        name: "eshop-offer",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "paiement",
        component: EshopHome,
        name: "eshop-checkout",
        meta: {
          schoolType: 'eschool',
        }
      },
      {
        path: "commande/:orderId",
        component: EshopHome,
        name: "eshop-order",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "connexion",
        component: EshopConnection,
        name: "connection-eshop",
        meta: {
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissioneschool/:school/profil",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: EschoolProfile,
        name: "eschool-profile",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      }
    ]
  },

  {
    path: "/admissioneschool",
    component: MainLayout,
    children: [
      {
        path: "/",
        component: EschoolHome,
        name: "eschool",
        meta: {
          schoolType: 'eschool',
          hasMenu: false
        }
      }
    ]
  },
  {
    path: "/admissioneschool/:school",
    component: MainLayout,
    meta: {
      schoolType: 'eschool'
    },
    children: [
      {
        path: "",
        component: EschoolApplication,
        name: "eschool-home",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "mon-compte",
        component: EschoolApplication,
        name: "eschool-application",
        meta: {
          schoolType: 'eschool',
          isCandidate: true,
          requiresAuth: true
        }
      },
      {
        path: "procedure",
        component: Process,
        name: "eschool-process"
      },
      {
        path: "contrat",
        component: EschoolContract,
        name: "eschool-contrat"
      },
      {
        path: "connexion",
        component: Connection,
        name: "eschool-connection",
        meta: {
          schoolType: 'eschool',
          hasMenu: false
        }
      },
      {
        path: "inscription",
        component: Registration,
        name: "eschool-registration",
        props: route => ({
          source: route.query.source,
          utm_source: route.query.utm_source,
          utm_medium: route.query.utm_medium,
          utm_campaign: route.query.utm_campaign,
          utm_content: route.query.utm_content,
          utm_term: route.query.utm_term
        }),
        meta: {
          schoolType: 'eschool',
          hasMenu: false
        }
      },
      {
        path: '404',
        alias: '*',
        component: NotFoundPage,
        name: "eschool-not-found"
      }
    ]
  }
];

// Vue Router Configuration
const router = new VueRouter({
  mode: "history",
  routes,
  // Bulma Active Class
  linkExactActiveClass: "is-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 500);
      });
    }
  }
});

// Prevent NavigationDuplicated errors globally
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const originalReplace = router.replace;
router.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

EventBus.$on("error:401", (data) => {
  // Ne pas logout si c'est une erreur email_not_verified (gérée par SignInForm)
  if (data && data.email_not_verified) {
    return;
  }

  const account = store.getters["auth/getAccount"];

  if (account.roles && account.roles.includes("admin")) {
    store.dispatch("auth/logout");
    if (router.currentRoute.path !== "/admin/login") {
      router.replace({ path: "/admin/login", query: { redirect: router.currentRoute.fullPath } });
    }
  }

  if (account.roles && account.roles.includes("candidate")) {
    const route = router.currentRoute;
    store.dispatch("auth/logout");
    let targetPath = "/admissionsup";

    if (route.params.school) {
      if (route.name && route.name.startsWith("eshop")) {
        targetPath = `/admissioneschool/${route.params.school}/offres/connexion`;
      } else if (route.params.school === "eschool") {
        targetPath = `/admissioneschool/${route.params.school}/connexion`;
      } else {
        targetPath = `/admissionsup/${route.params.school}/connexion`;
      }
    }

    if (route.path !== targetPath) {
      router.replace({ path: targetPath });
    }
  }
});

// Hooks
router.beforeEach((to, from, next) => {
  const { body } = document;
  const WIDTH = 768;
  const RATIO = 3;

  const handler = () => {
    if (!document.hidden) {
      const rect = body.getBoundingClientRect();
      const isMobile = rect.width - RATIO < WIDTH;
      store.dispatch("toggleDevice", isMobile ? "mobile" : "other");
      store.dispatch("toggleSidebar", {
        opened: !isMobile
      });
    }
  };

  document.addEventListener("visibilitychange", handler);
  window.addEventListener("DOMContentLoaded", handler);
  window.addEventListener("resize", handler);
  handler();

  /*if (to.matched.some(m => m.meta.isAdmin)) {
    store.dispatch("auth/checkAccount");
    return api.checkIsAdmin().then(response => {
      if (
          response.status !== 200 ||
          !response.data.user.roles.includes("admin") ||
          !store.getters["auth/isLoggedIn"]
      ) {
        store.dispatch("auth/logout");
        return next({ path: "/admin/login" });
      }
      return next();
    });
  }*/
  if (to.matched.some(m => m.meta.isAdmin)) {
    return api.checkIsAdmin().then(response => {

      if (response && response.status === 200) {
        //EventBus.$off('APPOINTMENT_CALL');
        EventBus.$emit('APPOINTMENT_CALL', response.data.user);
        store.commit('auth/setRefreshedAccount', response.data.user)
      }

      if (
        (response && response.status !== 200) ||
        !response.data.user.roles.includes("admin") ||
        !store.getters["auth/isLoggedIn"]
      ) {
        store.dispatch("auth/logout");
        return next({ path: "/admin/login", query: { redirect: to.fullPath } });
      }
      const account = store.getters["auth/getAccount"];
      
      const isSuperadmin = account.roles && account.roles.includes("superadmin");
      const isCommercial = account.roles && account.roles.includes("Commercial");
      const commercialDashboardPermissions = [
        "view own commercial dashboard",
        "view all commercial dashboards"
      ];

      if (to.path === "/admin" && hasAnyPermission(account, commercialDashboardPermissions)) {
        return next({ name: "commercial-dashboard" });
      }

      if (to.matched.some(m => m.meta && m.meta.superadminOnly) && !isSuperadmin) {
        return next({
          name: "Dashboard"
        });
      }

      if (to.name === "reminder-list" && to.params.status === "registered" && isCommercial && !isSuperadmin) {
        return next({
          name: "Dashboard"
        });
      }

      // Si la route n'a pas de permissions requises, autoriser l'accès
      if (!to.meta.permissions) {
        return next();
      }
      
      // Vérifier les permissions seulement si elles sont définies
      const hasRequiredPermission = hasAnyPermission(account, to.meta.permissions);
      if (!hasRequiredPermission && (to.meta.permissionsOnly || !isSuperadmin)) {
        return next({
          name: "Dashboard"
        });
      }
      return next();
    });
  }
  if (to.matched.some(m => m.meta.isCandidate)) {
    return api.checkIsAdmin().then(response => {
      if (
        response &&
        (response.status !== 200 ||
          response.data.user.roles.includes("admin") ||
          !store.getters["auth/isLoggedIn"])
      ) {
        store.dispatch("auth/logout");
        let targetPath = "/admissionsup";

        if (to.params.school) {
          if (to.name && to.name.startsWith("eshop")) {
            targetPath = `/admissioneschool/${to.params.school}/offres/connexion`;
          } else if (to.params.school === "eschool") {
            targetPath = `/admissioneschool/${to.params.school}/connexion`;
          } else {
            targetPath = `/admissionsup/${to.params.school}/connexion`;
          }
        }

        if (to.params.school) {
          if (to.path === targetPath) {
            return next(false);
          }
          return next({ path: targetPath, query: to.query });
        }

        if (to.path === targetPath) {
          return next(false);
        }

        return next({ path: targetPath, query: to.query });
      }
      return next();
    });
  }

  return next();
});

function hasAnyPermission(account, permissions) {
  const requiredPermissions = Array.isArray(permissions) ? permissions : [permissions];

  return Boolean(account && account.can && requiredPermissions.some(permission => account.can[permission]));
}

// Menu should have 2 levels.
function generateRoutesFromMenu(menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    const item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

export default router;
